import { render } from "./cipc_verification_form.html?vue&type=template&id=010715e9&external"
import script from "./cipc_verification_form.js?vue&type=script&lang=js&external"
export * from "./cipc_verification_form.js?vue&type=script&lang=js&external"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__